import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceMyApprovalListItem } from "@msuite/utils/types";
import {
	formatInvoiceAmount,
	formatInvoiceDate,
	IncomingInvoiceApprovalStateTag,
	IncomingInvoiceCheckBadges,
} from "@/components/incoming-invoices";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<IncomingInvoiceMyApprovalListItem>();

export const columns = [
	columnHelper.accessor("number", {
		id: "number",
		header: localized("incoming_invoices.number"),
		cell: (cell) => guardString(cell.getValue()),
		size: 180,
	}),
	columnHelper.accessor("issuerName", {
		id: "issuerName",
		header: localized("incoming_invoices.supplier"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("grossAmount", {
		id: "grossAmount",
		header: localized("incoming_invoices.gross_amount"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 140,
	}),
	columnHelper.accessor("dueDate", {
		id: "dueDate",
		header: localized("incoming_invoices.due_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 140,
	}),
	columnHelper.accessor((row) => row.checks.filter((check) => check.state === "failed").length, {
		id: "checks",
		header: localized("incoming_invoices.review"),
		cell: (cell) => (
			<IncomingInvoiceCheckBadges
				checks={cell.row.original.checks}
				currency={cell.row.original.currency}
			/>
		),
		size: 200,
	}),
	columnHelper.accessor("createdAt", {
		id: "createdAt",
		header: localized("incoming_invoices.requested_at"),
		cell: (cell) => moment(cell.getValue()).longFormat(),
		size: 160,
	}),
	columnHelper.accessor("state", {
		id: "state",
		header: localized("incoming_invoices.approval_state.state"),
		cell: (cell) => <IncomingInvoiceApprovalStateTag state={cell.getValue()} />,
		size: 130,
	}),
	columnHelper.accessor("decidedAt", {
		id: "decidedAt",
		header: localized("incoming_invoices.decided_at"),
		cell: (cell) => {
			const decidedAt = cell.getValue();
			return decidedAt ? moment(decidedAt).longFormat() : guardString(null);
		},
		size: 160,
	}),
	columnHelper.accessor("comment", {
		id: "comment",
		header: localized("incoming_invoices.approval_comment"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	createRowActions(RowActions),
];
